<template>
    <div v-if="isVisible" class="box card-box">
        <p class="small-box-title">
            Credit Card
        </p>
        <transition
            name="fade"
            mode="out-in"
        >
            <div v-if="false === userCard">
                <p class="no-payment-method-message">
                    No payment method available for this subscription.
                    <a
                        href="#"
                        @click.prevent="handleUpdate"
                    >
                        Add payment method
                    </a>
                </p>
            </div>
            <div
                v-else-if="!userCard"
                class="loader"
            >
                <i class="fas fa-spinner fa-spin loader" />
            </div>
            <div
                v-else
                class="card-info"
            >
                <span class="card-number">
                    <i :class="userCard.brandClass" />
                    **** ***** **** {{ userCard.last4 }}
                </span>
                <span class="card-expiry">Exp.  {{ userCard.expiryDate }}</span>
                <a
                    v-if="! user.migrated"
                    class="link"
                    href="#"
                    @click.prevent="handleUpdate"
                >
                    Update <span v-if="!upgradeOption">Credit Card</span>
                </a>
            </div>
        </transition>
        <new-app-prompt v-if="user.migrated" />
    </div>
</template>

<script>
import NewAppPrompt from './NewAppPrompt';

import {
    mapGetters,
    mapMutations,
    mapState,
} from 'vuex';

export default {
    components: {
        NewAppPrompt,
    },

    props: {
        upgradeOption: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapState([
            'currentSubscription',
            'user',
        ]),
        ...mapGetters(['userCard']),

        /**
         * @returns {boolean} Whether the component should be visible.
         */
        isVisible() {
            return 'lifetime' !== this.currentSubscription?.name;
        },
    },

    methods: {
        ...mapMutations(['changeUIState', 'userSubscriptionDetails']),

        /**
         * Handles open update click
         */
        handleUpdate() {
            if (this.upgradeOption) {
                this.$emit('switch-to-upgrade');
            } else {
                this.changeUIState({ isUpdateModalVisible: true });
            }
        },
    },
};
</script>
